import { formatearCOP } from '@tanteo/compartido';
import type { DescuentoDelNegocio } from '../../lib/api-descuentos';

/** El texto del botón de un descuento: «Cliente frecuente · 10%», «Combo · −$2.000 c/u», «2x1 · 2x1» o «Descuento libre…». */
export function textoDeDescuento(d: DescuentoDelNegocio, lugar: 'producto' | 'venta'): string {
  if (d.forma === 'lleva_paga') return `${d.nombre} · ${d.lleva}x${d.paga}`;
  if (d.forma === 'libre' || d.valor === null) return `${d.nombre}…`;
  if (d.forma === 'porcentaje') return `${d.nombre} · ${d.valor}%`;
  return `${d.nombre} · −${formatearCOP(d.valor)}${lugar === 'producto' ? ' c/u' : ''}`;
}
